module.exports = __webpack_public_path__ + "media/9.65f7d060.wav";